export const auth = {
  login: '登入',
  logout: '登出',
  username: '使用者名稱',
  email: '電子郵件',
  password: '密碼',
  forgotPassword: '忘記密碼？',
  invalidCredentials: '認證資訊無效',
  accountLocked: '帳戶已鎖定，請稍後再試。',
  accountDisabled: '帳戶已停用',
  twoFactorRequired: '需要雙重驗證碼',
  loginSuccess: '登入成功',
  welcomeBack: '歡迎回來',
  signInPrompt: '登入以存取您的管理控制台',
  emailOrUsername: '電子郵件或使用者名稱',
  enterEmail: '輸入您的電子郵件',
  enterPassword: '輸入您的密碼',
  developmentCredentials: '開發環境認證資訊',
  loginPageTitle: '高效管理您的電動車充電網路',
  loginPageSubtitle: '監控充電站、追蹤使用分析、管理使用者，並在一個地方優化您的電動車基礎設施。',
  twoFactorCode: '雙重驗證碼',
  enter6DigitCode: '輸入 6 位數驗證碼',
  twoFactorHint: '請輸入您的驗證器應用程式中的驗證碼',
  verifyAndSignIn: '驗證並登入',
};